import { BrowserRouter as Router, Route, Routes, Navigate, Link } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import DashboardLayout from './components/DashboardLayout';
import UserManagement from './components/user-management/UserManagement';
import Complaint from './components/complaint/Complaint';
import TermCondition from './components/TermCondition';
import AddComplaint from './components/complaint/AddComplaint';
import UpdateUser from './components/user-management/UpdateUser';
import UpdateAnnouncement from './components/complaint/UpdateAnnouncement';
import Privacy from './components/Privacy';

// Dummy components for routing

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/term-conditions" element={<TermCondition />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/main-panel" element={<DashboardLayout />} >
              <Route path="user-management" element={<UserManagement />} />
              <Route path="user-management/update-user" element={<UpdateUser />} />
              <Route path="complaint" element={<Complaint />} />
              <Route path="complaint/add-complaint" element={<AddComplaint />} />
              <Route path="complaint/update-complaint" element={<UpdateAnnouncement />} />
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />

          </Routes>
        </header>
      </div>
    </Router>
  );
}

export default App;
